module.exports = __webpack_public_path__ + "static/media/devs-logo-light.e8df458b.svg";